module.exports = __webpack_public_path__ + "img/sandy_and_lou.517172c5.png";